export default __webpack_public_path__ + "static/media/card-total-question-icon.63a58c15.svg";